// extracted by mini-css-extract-plugin
export default {"checkbox":"inputs_checkbox__j2yTS","label":"inputs_label__bvSlX","error":"inputs_error__IQVtP","input":"inputs_input__YrcSq"};